import { getTermValue, resetTerms } from '../../../../JsonQuery';
import { TTagsManager } from '../../types/tag';
import { createTagValue } from '../../utils/createTagValue';

const ID = 'commissionType' as const;

export const commissionTypeTagManager: TTagsManager = {
  id: ID,
  extractTagsFromJsonQuery: ({ jsonQuery }) => {
    const comissionType = getTermValue('commission_type')(jsonQuery);

    if (comissionType === null) {
      return null;
    }

    const label = comissionType === 1 ? 'Эксклюзивная комиссия' : 'Без комиссии';

    return [{ label, value: createTagValue(ID) }];
  },
  modifyJsonQueryByRemovingTag: ({ jsonQuery }) => resetTerms(['commission_type'])(jsonQuery),
};
